<tyt-default-content
  url="/resources/gift-membership-packages/toolkit"
  summary="Resources for members to help distribute their purchased gift membership packages."
  description=""
  [includeInSearch]="true"
  >

  <h1>Gift Membership Packages Toolkit/FAQ</h1>

  <h2>Overview</h2>
  <p>TYT members and non-members can buy a bulk number of memberships that can be redeemed en masse using a code or
    sign-up link. Membership sponsorships are a unique way to buy a larger quantity of memberships, for a group, campaign,
    company, or just to pay it forward!</p>

  <p>There are lots of ways you can distribute your sponsorship redemption codes.</p>

  <h2>Email</h2>
  <p>If you're looking to send out a bunch of sponsorships at once, look no further than your email contact list! You can
    just copy and paste your unique URL into an email and send it along. If you're sending to a bunch of emails at once,
    we suggest you put your contacts' email addresses in the BCC field of your email (instead of the To field).</p>

  <h2>Social Media</h2>
  <p>You can post your unique URL to your social media and let anyone who can see your post use one of your sponsored
    memberships!</p>

  <h2>Text Messaging</h2>
  <p>Text your friends and family your unique URL or the redemption code!</p>

  <h2>Student organizations and schools</h2>
  <p>If you want to donate to your favorite student organization or local school, just reach out to them directly and
    send them your unique URL.</p>

  <h2>Foundations / Nonprofits</h2>
  <p>Feel free to send your subscription(s) to your favorite foundation or non-profit. Or you can gift some of our
    favorite organizations and let them hand them out, too:
    <a href="https://www.wolf-pac.com/" target="_blank">Wolf-PAC</a>, <a href="https://www.justicedemocrats.com/" target="_blank">Justice Democrats</a></p>

  <h2>Special Events and Meetings</h2>
  <p>Offer TYT membership codes to attendees of your next meeting or event. Codes can be emailed to confirmed guests,
    added to swag bags, or given as prizes for participating in certain sessions or contests.</p>

  <h2>Campaign Teams</h2>
  <p>Want to show some appreciation to your favorite campaign team? Send them the gift of TYT membership for a job well
    done.</p>

    <a routerLink="/settings/memberships">Back to Membership Accounts</a>
</tyt-default-content>

